import { jsonRequest } from '../utils/request'
import { PathEnum } from '../enum/pathEnum'
export default class StoreService {
  // 获取全部的店铺列表
  static async getAllShopList() {
    const res = await jsonRequest(PathEnum.STORELIST)
    return res.data.result
  }
}
